import React, { useState, useEffect } from 'react'
import { Pagination } from "antd"
import BatchesFilters from "./filters/BatchesFilters"
import BatchesTable from "./table/BatchesTable"
import { Link } from "react-router-dom"
import { getItemsColorSystemError } from "../../../services/api/3dApi"
import { getListBrand } from '../../../services/api/3dApi'

const ColorSystemPage = () => {
    const [filters, setFilters] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [batches, setBatches] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(50)
    const [selectedBatchId, setSelectedBatchId] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [listBrand, setListBrand] = useState([])

    async function getItemColorSystemError() {
        try {
            setLoading(true)
            setError('')

            const { tags, ...rest } = { ...filters }
            const payload = {
                ...rest,
                page,
                limit
            }

            if (!!tags && tags.length) payload.tags = tags.some(i => i === "FBA") ? [...tags, 'fba'] : tags

            const { data: response } = await getItemsColorSystemError(payload)

            const { success, data, message, error } = response

            if (!success) {
                setLoading(false)
                return setError(message || error)
            }

            setSelectedAll(false)
            setSelectedBatchId([])
            setLoading(false)
            setBatches(data.items)
            setTotal(data.total)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    function _handleChangeInput(field, value) {
        if (field === 'brand' && !value.length) {
            delete filters[field]
            setFilters({ ...filters })
        } else {
            setFilters({
                ...filters,
                [field]: value
            })
        }
        setPage(1)
    }

    function _handleShowSizeChange(current, size) {
        setLimit(size)
        setPage(1)
    }

    function _handleChangeProductType(value) {
        setFilters({
            ...filters,
            product_types: value
        })
        setPage(1)
    }

    function _handleChangeDate(filtersValue) {
        setFilters({
            ...filters,
            ...filtersValue
        })
        setPage(1)
    }

    function _handlePageChange(page) {
        setPage(page)
    }

    function _toggleSelectAll(isChecked) {
        if (isChecked) {
            const listIds = []

            batches.map(batch => listIds.push(batch._id))

            setSelectedBatchId(listIds)
            setSelectedAll(true)
        } else {
            setSelectedBatchId([])
            setSelectedAll(false)
        }
    }

    function _updateSelectedBatches(id, isAdded) {
        if (isAdded && !selectedBatchId.includes(id)) {
            setSelectedBatchId([...selectedBatchId, id])
            setSelectedAll(selectedBatchId.length + 1 === batches.length)
        } else {
            const filtered = selectedBatchId.filter(batch => batch !== id)

            setSelectedBatchId(filtered)
            setSelectedAll(false)
        }
    }

    function _resetSelected() {
        setSelectedAll(false)
        setSelectedBatchId([])
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getItemColorSystemError()
    }, [page, limit, filters])

    useEffect(() => {
        _getListBrand()
    }, [])

    return (
        <div className='ColorSystemPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách lỗi hệ màu</h3>
                            <Link to="/batches" className="ant-btn ant-btn-default">Quay về danh sách lô</Link>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <BatchesFilters
                                loading={loading}
                                filters={filters}
                                listBrand={listBrand}
                                onChangeInput={_handleChangeInput}
                                onChangeDate={_handleChangeDate}
                                onChangeProductType={_handleChangeProductType}
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} />
                        </div>
                        <div className="BatchesTableContainer">
                            <BatchesTable
                                status={filters.status}
                                batches={batches}
                                loading={loading}
                                selectedAll={selectedAll}
                                selectedBatchId={selectedBatchId}
                                onResetSelected={_resetSelected}
                                getItemColorSystemError={getItemColorSystemError}
                                onChangeProductType={_handleChangeProductType}
                                onSelectAll={_toggleSelectAll}
                                onUpdateSelectedBatches={_updateSelectedBatches}
                                handleChangeInput={_handleChangeInput}
                            />
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={_handlePageChange}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ColorSystemPage